import { InjectionToken } from '@angular/core';

export const ENVIRONMENT_CONFIG = new InjectionToken(
  'ENVIRONMENT_CONFIG'
);
export const ROUTE_INFO = new InjectionToken(
  'ROUTE_INFO'
);